import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { getServices } from "../../apiServices/apiServices";
import toast from "react-hot-toast";
import { IoChevronBackOutline } from "react-icons/io5";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Tab } from "@mui/material";
import LoadingGif from "../../assets/loading_anim.gif";
import GldLogsTable from "../../components/common/GldLogsTable";

function HeadGLDLogs() {
  const [loading, setLoading] = useState(false);
  const [gldWindowList, setGldWindowList] = useState([]);
  const [gldLogList, setGldLogList] = useState([]);
  const [tabValue, setTabValue] = useState("1");
  const location = useLocation().state;
  const access_token = localStorage.getItem("gassol-head-branch-token");

  useEffect(() => {
    fetchGldLogList(true);

    const fetchAndSchedule = async () => {
      await fetchGldWindowList(true); // Call the function initially
      const interval = setInterval(fetchGldWindowList, 30000); // Call the function every 30 seconds
      return () => clearInterval(interval); // Cleanup interval on component unmount
    };

    fetchAndSchedule(); // Call the wrapper function

    return () => {
      clearInterval(fetchAndSchedule); // Cleanup
    };
  }, []);

  const fetchGldWindowList = async (load_status) => {
    setLoading(load_status);
    try {
      const res = await getServices(
        `/api/hardware/gld/window?id=${location.controllerDetails?.hardware_id}`,
        access_token
      );
      setLoading(false);
      if (res.responseCode === 200) {
        setGldWindowList(res.responseData);
      } else {
        setGldWindowList([]);
      }
    } catch (error) {
      setLoading(false);
      toast.error(error);
    }
  };

  const fetchGldLogList = async (load_status) => {
    setLoading(load_status);
    try {
      const res = await getServices(
        `/api/hardware/gld/log?id=${location.controllerDetails?.hardware_id}`,
        access_token
      );
      setLoading(false);
      if (res.responseCode === 200) {
        setGldLogList(res.responseData);
      } else {
        setGldLogList([]);
      }
    } catch (error) {
      setLoading(false);
      toast.error(error);
    }
  };

  const filterDataByStatus = (status) => {
    return gldLogList.filter((item) => item.sen_status === status);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <>
      <div className="py-4 md:py-6 max-w-[1400px] mx-auto px-3">
        <>
          <div className="flex gap-2 justify-between items-center flex-row">
            <div className="flex justify-between gap-3 sm:gap-6">
              <Link
                to={-1}
                className="flex gap-2 items-center font-semibold text-xl text-[#BDBDBD]"
              >
                <IoChevronBackOutline />
                <p>GLD Window & Logs</p>
              </Link>
            </div>
          </div>

          {!loading ? (
            <>
              {gldWindowList?.length > 0 && (
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mt-5">
                  {gldWindowList?.map((log, i) => (
                    <div
                      key={i}
                      className="drop-shadow-2xl bg-white py-4 sm:py-7 px-4 sm:px-7 rounded-3xl h-fit flex flex-col gap-3"
                    >
                      <p className="font-bold capitalize">
                        Zone Name: {log.zone_name}
                      </p>
                      {log.sensors?.map((sensor, i) => (
                        <div
                          key={i}
                          className="flex justify-between items-center capitalize"
                        >
                          <p>Sensor {sensor.sensor}</p>
                          <p
                            className="font-medium"
                            style={{
                              color:
                                sensor.sen_status == 1
                                  ? "#FF0000"
                                  : sensor.sen_status == 2
                                  ? "#FFA500"
                                  : sensor.sen_status == 3
                                  ? "#FFFF00"
                                  : sensor.sen_status == 4
                                  ? "#808080"
                                  : sensor.sen_status == 5
                                  ? "#00FF00"
                                  : "-",
                            }}
                          >
                            {sensor.sen_status == 1
                              ? "Major Leakage"
                              : sensor.sen_status == 2
                              ? "Minor Leakage"
                              : sensor.sen_status == 3
                              ? "Sensor Fault"
                              : sensor.sen_status == 4
                              ? "Power Off"
                              : sensor.sen_status == 5
                              ? "Working"
                              : "-"}
                          </p>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              )}

              <div className="mt-7 font-bold text-xl">
                <p>GLD Log</p>

                <div className="my-2">
                  <TabContext value={tabValue}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <TabList
                        onChange={handleTabChange}
                        aria-label="lab API tabs example"
                        variant="scrollable"
                        sx={{
                          "& .MuiTab-root": {
                            fontFamily: "Poppins",
                          },
                        }}
                      >
                        <Tab label="Major Leakage" value="1" />
                        <Tab label="Minor Leakage" value="2" />
                        <Tab label="Sensor Fault" value="3" />
                        <Tab label="Power Off" value="4" />
                        {/* <Tab label="Working" value="5" /> */}
                      </TabList>
                    </Box>
                    <TabPanel value="1">
                      <GldLogsTable data={filterDataByStatus("1")} />
                    </TabPanel>
                    <TabPanel value="2">
                      <GldLogsTable data={filterDataByStatus("2")} />
                    </TabPanel>
                    <TabPanel value="3">
                      <GldLogsTable data={filterDataByStatus("3")} />
                    </TabPanel>
                    <TabPanel value="4">
                      <GldLogsTable data={filterDataByStatus("4")} />
                    </TabPanel>
                    {/* <TabPanel value="5">
                      <GldLogsTable data={filterDataByStatus("5")} />
                    </TabPanel> */}
                  </TabContext>
                </div>
              </div>
            </>
          ) : (
            <div className="w-full flex justify-center items-center h-[90vh]">
              <img src={LoadingGif} alt="" />
            </div>
          )}
        </>
      </div>
    </>
  );
}

export default HeadGLDLogs;
